import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import Dropzone, { useDropzone } from 'react-dropzone';
import Button from '../button/Button';
const FilePicker = props => {
    const { label, accept, multiple, maxSize, displayMode, onPick, className, children } = props, remainigProps = __rest(props, ["label", "accept", "multiple", "maxSize", "displayMode", "onPick", "className", "children"]);
    const dropzoneRef = useRef();
    const isButton = displayMode === 'button';
    const isDropzone = displayMode === 'dropzone';
    const isFull = displayMode === 'full';
    const showButton = isButton || isFull;
    const showDropzone = isDropzone || isFull;
    const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
        const hasImagesType = accept && Object.keys(accept).some(mimeType => mimeType.startsWith('image'));
        const files = hasImagesType
            ? acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file),
            }))
            : acceptedFiles;
        onPick(files, rejectedFiles);
    }, [onPick, accept]);
    const onOpenClick = () => dropzoneRef.current.open();
    return (_jsxs("div", Object.assign({ className: 'FilePicker' }, { children: [showButton && (_jsx(Button, Object.assign({ onClick: onOpenClick, className: className }, { children: label }))), _jsx(Dropzone, Object.assign({}, remainigProps, { onDrop: handleDrop, accept: accept, multiple: multiple, maxSize: maxSize, ref: dropzoneRef }, { children: ({ getRootProps, getInputProps, isDragActive }) => {
                    return (_jsxs("div", Object.assign({}, getRootProps(), { children: [_jsx("input", Object.assign({}, getInputProps())), showDropzone && children && children({ isDragActive })] })));
                } }))] })));
};
FilePicker.DISPLAY_MODE_BUTTON = 'button';
FilePicker.DISPLAY_MODE_DROPZONE = 'dropzone';
FilePicker.DISPLAY_MODE_FULL = 'full';
FilePicker.defaultProps = {
    displayMode: 'button',
    multiple: true,
    label: 'Select Files',
    onPick: () => { },
    className: '',
};
FilePicker.propTypes = {
    displayMode: PropTypes.string /* Display mode: 'dropzone' / 'button' / 'full' */,
    multiple: PropTypes.bool /* Allow multiple file selections or not */,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]) /* Text to display on Button */,
    accept: PropTypes.object /* Object list of accepted Mime Types as keys and file extensions array as value */,
    maxSize: PropTypes.number /* Maximum File Size */,
    onPick: PropTypes.func /* Pick callback */,
    className: PropTypes.string /* Custom className for the displayed component (dropzone/button) */,
    children: PropTypes.any,
};
export default FilePicker;
